<template>
    <div class="company-info-form">
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form role="form" class="mt-4">
                <b-row>
                    <b-col cols="12"><h4>Current Employment</h4></b-col>
                    <b-col cols="8">
                        <b-form-group label="Company Name">
                            <b-form-input
                            v-model="form.current.name"
                            type="text"
                            placeholder="Enter company name"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Company Registration No.">
                            <b-form-input
                            v-model="form.current.registration_no"
                            type="text"
                            placeholder="Enter Company Registration No."
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Company Telephone">
                            <div class="d-flex justify-content-between">
                                <b-form-input class="col-md-3 mr-1" v-model="form.current.country_code"></b-form-input>
                                <b-form-input
                                    class="col-md-9"
                                    v-model="form.current.contact_no"
                                    type="text"
                                    maxlength="17"
                                    @keydown="preventNonNumericInput"
                                    placeholder="Enter Company Telephone"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Company Address">
                            <b-form-input
                            v-model="form.current.address_1"
                            type="text"
                            placeholder="Enter Company Address"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Company Nature of Business">
                            <b-form-input
                            v-model="form.current.business_nature"
                            type="text"
                            placeholder="Enter Company Nature of Business"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <!-- <b-col cols="8">
                        <b-form-group label="Company Nature of Business">
                            <el-select v-model="form.current.business_nature_id" placeholder="Select">
                                <el-option
                                v-for="item in tables.business_natures"
                                :key="item.business_nature_id"
                                :label="item.name"
                                :value="item.business_nature_id">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col> -->

                    <b-col cols="8">
                        <b-form-group label="Department">
                            <b-form-input
                            v-model="form.current.business_department"
                            type="text"
                            placeholder="Enter Department"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <!-- <b-col cols="8">
                        <b-form-group label="Department">
                            <el-select v-model="form.current.business_department_id" placeholder="Select">
                                <el-option
                                v-for="item in tables.business_departments"
                                :key="item.business_department_id"
                                :label="item.name"
                                :value="item.business_department_id">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col> -->

                    <b-col md="8" cols="12">
                        <b-form-group label="Title/Position">
                            <b-form-input
                            v-model="form.current.position"
                            type="text"
                            placeholder="Enter Title/Position"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Company HR Contact">
                            <div class="d-flex justify-content-between">
                                <b-form-input class="col-md-3 mr-1" v-model="form.current.hr_country_code">
                                </b-form-input>
                                <b-form-input
                                    v-model="form.current.hr_contact_no"
                                    type="text"
                                    maxlength="17"
                                    @keydown="preventNonNumericInput"
                                    placeholder="Enter Company HR Contact"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Company HR Email">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ email: true }"
                                :vid="'email'"
                            >
                                <b-form-input
                                v-model="form.current.hr_email"
                                type="email"
                                placeholder="Enter Company HR Email"
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Length of Service (Year)">
                            <b-form-input
                            v-model="form.current.length_of_service"
                            type="number"
                            placeholder="Enter Length of Service"
                            ></b-form-input>
                            <div>
                                <b-form-radio v-model="form.current.length_of_service_type" name="length_of_service_type" value="year">
                                    Year
                                </b-form-radio>
                                <b-form-radio v-model="form.current.length_of_service_type" name="length_of_service_type" value="month">
                                    Month
                                </b-form-radio>
                            </div>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12">
                        <b-form-group label="Employment Type">
                            <el-radio-group v-model="form.current.employment_type_id">
                                <el-radio-button :label="employment_type.employment_type_id" v-for="employment_type in tables.employment_types" 
                                    :key="employment_type.employment_type_id"
                                >{{ employment_type.type }}</el-radio-button>
                            </el-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12"><h4>Previous Employment</h4></b-col>
                    
                    <b-col cols="8">
                        <b-form-group label="Company Name">
                            <b-form-input
                            v-model="form.previous.name"
                            type="text"
                            placeholder="Enter company name"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Length of Service (Year)">
                            <b-form-input
                            v-model="form.previous.length_of_service"
                            type="number"
                            placeholder="Enter Length of Service"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="8">
                        <b-form-group>
                            <label>
                                Company Type
                            </label>
                            <div class="d-flex flex-wrap">
                                <b-form-radio
                                    v-model="form.current.company_type"
                                    name="companyType"
                                    value="MNC"
                                    class="mr-3"
                                >
                                    MNC
                                </b-form-radio>
                                <b-form-radio
                                    v-model="form.current.company_type"
                                    name="companyType"
                                    value="GLC"
                                    class="mr-3"
                                >
                                    GLC
                                </b-form-radio>
                                <b-form-radio
                                    v-model="form.current.company_type"
                                    name="companyType"
                                    value="PLC"
                                    class="mr-3"
                                >
                                    PLC
                                </b-form-radio>
                                <b-form-radio
                                    v-model="form.current.company_type"
                                    name="companyType"
                                    value="Sdn Bhd"
                                    class="mr-3"
                                >
                                    Sdn Bhd
                                </b-form-radio>
                                <b-form-radio
                                    v-model="form.current.company_type"
                                    name="companyType"
                                    value="Sole Proprietor or Partnership"
                                    class="mr-3"
                                >
                                    Sole Proprietor or Partnership
                                </b-form-radio>
                                <b-form-radio
                                    v-model="form.current.company_type"
                                    name="companyType"
                                    value="Non MNC"
                                    class="mr-3"
                                >
                                    Non MNC
                                </b-form-radio>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col cols="8">
                        <b-button block variant="primary" class="w-50" @click.prevent="update" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton } from 'element-ui'
import {
notifyFunctionMixin,
axios,
services,
getHeader
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'

    export default {
        name: 'company-info-form',
        props: ['customer', 'tables'],
        mixins:[
            notifyFunctionMixin,
        ],
        components: {
            ValidationObserver,
            ValidationProvider,
            [Select.name]: Select,
            [Option.name]: Option,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
        },
        data() {
            const { companies } = this.customer;
            const current_company = companies.current || {};
            const previous_company = (companies.others?.[0]) || {};

            return {
                form: {
                    current: {
                        customer_company_id: current_company.customer_company_id ?? null,
                        name: current_company.name ?? null,
                        registration_no: current_company.registration_no ?? null,
                        country_code: current_company.country_code ?? '+60',
                        contact_no: current_company.contact_no ?? null,
                        address_1: current_company.address_1 ?? null,
                        business_nature: current_company.business_nature ?? null,
                        business_department: current_company.business_department ?? null,
                        business_nature_id: current_company.business_nature_id ?? null,
                        business_department_id: current_company.business_department_id ?? null,
                        position: current_company.position ?? null,
                        hr_country_code: current_company.hr_country_code ?? '+60',
                        hr_contact_no: current_company.hr_contact_no ?? null,
                        hr_email: current_company.hr_email ?? null,
                        length_of_service: current_company.length_of_service ?? null,
                        length_of_service_type: current_company.length_of_service_type ?? null, 
                        employment_type_id: current_company.employment_type_id ?? null,
                        is_current: true,
                        company_type:  current_company.company_type ?? null,
                    },
                    previous: {
                        customer_company_id: previous_company.customer_company_id ?? null,
                        name: previous_company.name ?? null,
                        length_of_service: previous_company.length_of_service ?? null,
                        is_current: false,
                    },
                },
            };
        },
        watch:{
            customer(newVal, oldVal){
                if (newVal){
                    const currentCompany = newVal.companies.current || {}
                    const otherCompany = newVal.companies.others[0] || {}
    
                    this.form.current.customer_company_id = currentCompany.customer_company_id
                    this.form.previous.customer_company_id = otherCompany.customer_company_id
                }
            }
        },
        methods:{
            ...mapActions(useCustomerStore,['getCustomer']),
            update(){
                const companies = [];
                companies.push({...this.form.current})
                
                if(this.form.previous.name || this.form.previous.length_of_service){
                    companies.push({...this.form.previous})
                }
                
                axios.post(services.customer + 'customer/'+this.customer.customer_id+'/companies', { companies: companies }, {headers: getHeader()})
                .then(res => {
                        this.notifySuccess('<b>Company Information: '+this.customer.name+'</b> - Successfully Updated.')
                        this.getCustomer(this.customer.customer_id)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            preventNonNumericInput(event) {
                const keyCode = event.keyCode || event.which;
                const keyValue = String.fromCharCode(keyCode);
                const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
                const allowedKeys = [8, 37, 38, 39, 40, 46];
                if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                    event.preventDefault();
                }
            },
        },
    }
</script>